import { render } from "./Recaptcha.vue?vue&type=template&id=53e7d167"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Recaptcha.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e7d167"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e7d167', __exports__)) {
    console.log('reload')
    api.reload('53e7d167', __exports__)
  }
  
  module.hot.accept("./Recaptcha.vue?vue&type=template&id=53e7d167", () => {
    console.log('re-render')
    api.rerender('53e7d167', render)
  })

}


export default __exports__